import {BTTrackerBase} from './base';

export class CagePointTracker extends BTTrackerBase {
  configure({cagePointProjectId, ...restConfig}, ...restArgs) {
    super.configure({cagePointProjectId, ...restConfig}, ...restArgs);
    this.cagePointProjectId = cagePointProjectId;

    if (!cagePointProjectId) {
      this.disable();
      this.log('CagePoint has been disabled because no tag was specified.');
    }
  }

  getName() {
    return 'CagePointTracker';
  }

  get requiresTrackingConsent() {
    return true;
  }

  get restrictsEventsWithoutConsent() {
    return true;
  }

  async init(...params) {
    await this.loadTag();
    this.log('CagePoint initialized', {cagePointProjectId: this.cagePointProjectId});
    super.init(...params);
  }

  loadTag() {
    const self = this;
    return new Promise(resolve => {
      /* eslint-disable */
      window.Aggregator = window.Aggregator || function (o) {
        var d = document,
          p = Aggregator.prototype;
        this.options = o;
        this.q = [];
        d.cookie = "__na_c=1";
        p.p = function (c) {
          return function () {
            this.q.push([c, arguments]);
          };
        };
        p.setPerson = p.p(4, arguments);
        p.logEvent = p.p(0, arguments);
        p.logPageview = p.p(1, arguments);
        p.ready = p.p(2, arguments);
        p.logOutbound = p.p(3, arguments);
        p.updatePerson = p.p(5, arguments);
        p.updateSession = p.p(6, arguments);
        p.updateEvent = p.p(7, arguments);
        p.push = p.p(8, arguments);

        var s = d.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        (function (i) {
          s.onreadystatechange = function () {
            if (s.readyState == "loaded" || s.readyState == "complete") {
              self.log('Gator API loaded via readyState change');
              i.run();
              resolve();
            }
          };
          s.onload = function () {
            self.log('Gator API loaded via script onload function');
            i.run();
            resolve();
          };
        })(this);
        e = location.protocol == "https:";
        s.src =
          "http" +
          (e ? "s://" : "://") +
          (e && navigator.userAgent.indexOf("MSIE") > -1
              ? "a-{0}.gatorapi.com"
              : "a-{0}.scripts.gatorapi.com"
          ).replace("{0}", o.projectId) +
          "/web?t=" +
          Math.floor((new Date() * 0.00001) / 36);
        var e = d.getElementsByTagName("script")[0];
        e.parentNode.insertBefore(s, e);
      };
      /* eslint-enable */
      this.gator = new window.Aggregator({projectId: this.cagePointProjectId});
    });
  }

  view(...params) {
    if (!super.view(...params)) {
      return false;
    }

    this.gator.logPageview();
    this.log('CagePoint page view event fired');
    return true;
  }

  purchase(order, items, {addon} = {}) {
    if (!super.purchase(order, items, {addon})) {
      return false;
    }

    if (!order) {
      this.log(
        'CagePoint conversion tracker will not fire because the order is missing',
        order,
      );
      return false;
    }

    const purchaseData = {
      id: order.id,
      revenue: order.subtotal,
      tax: order.taxes,
      shipping: order.shipping,
      // eslint-disable-next-line camelcase
      order_type: 0,
    };

    if (addon) {
      purchaseData.id = `${order.id}-${order.step}`;
      purchaseData.tax = 0;
      purchaseData.shipping = 0;
      /* eslint-disable camelcase */
      purchaseData.original_order_id = order.id;
      purchaseData.order_type = 1;
      /* eslint-enable camelcase */
    }

    this.gator.logEvent('Order', purchaseData);
    this.log('CagePoint purchase event fired', purchaseData);
    return true;
  }
}
